import * as React from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import RedditIcon from '@mui/icons-material/Reddit';
import NooderaButton from 'components/NooderaButton/index';
import type { SocialMediaIconProps } from './SocialMediaIcons.types';
import { StyledSocialLink, WrapperSocialIcon } from './SocialMediaIcons.styles';

const SocialMediaIcons = ({ icon, url }: SocialMediaIconProps): React.ReactElement<any> => {
  const getSocialIcon = (socialIcon: React.ReactElement<any>, altText: string) => (
    <StyledSocialLink
      to={{
        pathname: url,
      }}
      target='_blank'
      aria-label={altText}
      tabIndex={0}
    >
      <NooderaButton.RoundCTA size='medium' aria-hidden='true' tabIndex={-1}>
        <WrapperSocialIcon>{socialIcon}</WrapperSocialIcon>
      </NooderaButton.RoundCTA>
    </StyledSocialLink>
  );

  switch (icon) {
    case 'Facebook':
      return getSocialIcon(<FacebookIcon />, 'Facebook');

    case 'Twitter':
      return getSocialIcon(<TwitterIcon />, 'Twitter');

    case 'Instagram':
      return getSocialIcon(<InstagramIcon />, 'Instagram');

    case 'LinkedIn':
      return getSocialIcon(<LinkedInIcon />, 'LinkedIn');

    case 'YouTube':
      return getSocialIcon(<YouTubeIcon />, 'YouTube');

    case 'Reddit':
      return getSocialIcon(<RedditIcon />, 'Reddit');

    default:
      return getSocialIcon(<FacebookIcon />, 'Facebook');
  }
};

export default SocialMediaIcons;
